








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../mti/metadata_pb.js');
goog.exportSymbol('proto.mti.PhysicalKeyState',null,global);











proto.mti.PhysicalKeyState=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.PhysicalKeyState,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.PhysicalKeyState.displayName='proto.mti.PhysicalKeyState';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.PhysicalKeyState.prototype.toObject=function(opt_includeInstance){
return proto.mti.PhysicalKeyState.toObject(opt_includeInstance,this);
};











proto.mti.PhysicalKeyState.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
checksum:msg.getChecksum_asB64(),
keyCount:jspb.Message.getFieldWithDefault(msg,4,0),
securityDeviceSerialNumber:jspb.Message.getFieldWithDefault(msg,5,"")};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.PhysicalKeyState.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.PhysicalKeyState();
return proto.mti.PhysicalKeyState.deserializeBinaryFromReader(msg,reader);
};









proto.mti.PhysicalKeyState.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readBytes();
msg.setChecksum(value);
break;
case 4:
var value=reader.readUint64();
msg.setKeyCount(value);
break;
case 5:
var value=reader.readString();
msg.setSecurityDeviceSerialNumber(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.PhysicalKeyState.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.PhysicalKeyState.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.PhysicalKeyState.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getChecksum_asU8();
if(f.length>0){
writer.writeBytes(
3,
f);

}
f=message.getKeyCount();
if(f!==0){
writer.writeUint64(
4,
f);

}
f=message.getSecurityDeviceSerialNumber();
if(f.length>0){
writer.writeString(
5,
f);

}
};






proto.mti.PhysicalKeyState.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.PhysicalKeyState.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.PhysicalKeyState.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.PhysicalKeyState.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.PhysicalKeyState.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.PhysicalKeyState.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.PhysicalKeyState.prototype.getChecksum=function(){
return jspb.Message.getFieldWithDefault(this,3,"");
};







proto.mti.PhysicalKeyState.prototype.getChecksum_asB64=function(){
return jspb.Message.bytesAsB64(
this.getChecksum());
};









proto.mti.PhysicalKeyState.prototype.getChecksum_asU8=function(){
return jspb.Message.bytesAsU8(
this.getChecksum());
};



proto.mti.PhysicalKeyState.prototype.setChecksum=function(value){
jspb.Message.setProto3BytesField(this,3,value);
};






proto.mti.PhysicalKeyState.prototype.getKeyCount=function(){
return jspb.Message.getFieldWithDefault(this,4,0);
};



proto.mti.PhysicalKeyState.prototype.setKeyCount=function(value){
jspb.Message.setProto3IntField(this,4,value);
};






proto.mti.PhysicalKeyState.prototype.getSecurityDeviceSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,5,"");
};



proto.mti.PhysicalKeyState.prototype.setSecurityDeviceSerialNumber=function(value){
jspb.Message.setProto3StringField(this,5,value);
};


goog.object.extend(exports,proto.mti);